import { render, staticRenderFns } from "./TimetableCard.vue?vue&type=template&id=018c67bd&scoped=true"
import script from "./TimetableCard.vue?vue&type=script&lang=js"
export * from "./TimetableCard.vue?vue&type=script&lang=js"
import style0 from "./TimetableCard.vue?vue&type=style&index=0&id=018c67bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c67bd",
  null
  
)

export default component.exports